export default __webpack_public_path__ + "static/media/lucky-spin-banner-ms.451c4710.webp";